<template>
  <div class="centerx sidebar">
    <vs-sidebar position-right parent="body" default-index="1" class="sidebarx" v-model="active">
      <div class="content with--background">
        <section class="section--sidebar-user">
          <section class="section--title-sidebar">
              <h3>Nuovo</h3>
          </section>
          <section class="section--content-sidebar section--content-sidebar-full-height">
            <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data">
              <div class="form-group">
                <label for="person_id" class="">{{__('forms.PayItemsPeople.person')}}</label>
                <!-- v-model="this.parameters.cause_id" -->
                <!-- <multiselect v-model="value" :options="options"></multiselect> -->
                <multiselect required="true" v-model="selectedPerson" :options="people" placeholder="Select one" label="identifiable_name" track-by="identifiable_name"></multiselect>
              </div>
              <div class="form-group">
                <label for="role_id" class="">{{__('forms.PayItemsPeople.pay_item')}}</label>
                <!-- v-model="this.parameters.cause_id" -->
                <multiselect required="true" v-model="selectedPayItem" :options="pay_items" placeholder="Select one" label="name" track-by="name"></multiselect>
              </div>
              <div class="form-group">
                <label for="person_id" class="">{{__('forms.PayItemsPeople.person')}}</label>
                <input required="true" v-model="selectedPerson" :options="people" placeholder="Select one" label="identifiable_name" track-by="identifiable_name"></multiselect>
              </div>
              <div class="form-group">
                <label for="name" class="">{{__('forms.PayItemsPeople.starting_from_at')}}</label>
                <vue-datepicker
                input_class="form-control"
                input_name="payItemPerson[starting_from_at]"
                :input_value="this.parameters.starting_from_at"
                ></vue-datepicker>
              </div>
              <input type="hidden" name="_token" :value="csrf">
              <input v-if="this.editing" type="hidden" name="_method" value="PUT">
              <input type="hidden" name="payItemPerson[person_id]" :value="this.selectedPerson.id">
              <input type="hidden" name="payItemPerson[pay_item_id]" :value="this.selectedPayItem.id">
              <div class="form-buttons clear">
                <button type="submit" class="btn btn--green">{{ __('misc.update') }} </button>
              </div>
            </form>
          </section>
        </section>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>

  export default {
    // <multiselect v-model="value" :options="options"></multiselect>
    // OR register locally
    //components: { Multiselect },
    data () {
      return {
        value: null,
        editing: false,
        active: false,
        action: "",
        title: "",
        parameters: {},
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        selectedPerson: {},
        selectedPayItem: {},

      }
    },
    methods: {
      toggle(action, item_id, editing, attributes) {
        console.log(attributes.roles);
        this.active = true;
        this.action = action;
        this.editing = editing;
        let url = attributes.url;
        if (url!==undefined) {
          if (url.indexOf("[id]")>0) {
            url = url.replace("[id]", item_id);
          }
          axios.get(url)
              .then((response) => {
                this.parameters = response.data;
              });
        }
      }
    },
    mounted() {
    },
    props: {
      pay_items: {
        type: Array,
        required: true
      },
      people: {
        type: Array,
        required: true
      },
    }

  }
</script>

<style>
	.hidden {
		display: none;
	}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>